import { UserLookupResponse } from './types'

export const isUserLookupResponseType = (obj: any): obj is UserLookupResponse => 'existing' in obj
